import axios, { AxiosRequestConfig } from "axios"
import IEntityIncident from '../../interfaces/entityIncident/IEntityIncident'
import { reactMainApiBaseUrl, customerKey, msalMainApiRequest } from "../../../configuration"
import { IPublicClientApplication } from '@azure/msal-browser'
import GetAccessToken from '../../functions/security/AccessTokenProvider'
import IIncidentAssignment from "../../interfaces/incidentAssignment/IIncidentAssignment"


export default async function CreateIncidentAssignment(publicClientApplication:IPublicClientApplication, customerID:string, username:string, entityIncidents: IEntityIncident[], assignToUserID: string, comment: string) {

  const accessToken = await GetAccessToken(publicClientApplication, msalMainApiRequest)
  const parameters = await createRequestParameters()

  let incidentAssignments:IIncidentAssignment[] = entityIncidents.map((entityIncident:IEntityIncident) => {
    return {
      "recordID": entityIncident.record.id,
      "userID": username,
      "customerID": customerID,
      "domain": entityIncident.entity.domain,
      "incidentName": entityIncident.incident.name,
      "assignToUserID": assignToUserID,
      "comment": comment
    } as IIncidentAssignment;
  });

  const requestConfiguration:AxiosRequestConfig = {
    url: (reactMainApiBaseUrl(customerID) + '/incident-assignments'),
    method: 'POST',
    params: parameters,
    headers: { Authorization: ('Bearer ' + accessToken)},
    data: incidentAssignments
  }
  
  return axios(requestConfiguration)
  .then(result => result.data)
  .catch(event => {throw Error("Could not send the incident assignments.\n\n" + event)})
}

const createRequestParameters = async () => {

  const parameters = new URLSearchParams()

  parameters.append('code', customerKey)

  return parameters
}